<template>
    <el-card class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
            <span>不同 Size 的评论分布及趋势</span>
        </div> 
        <div style="display: flex;min-width: 1100px;">
            <div id="variant2_1" style="width: 600px;height:400px;"></div>
            <div id="variant2_2" style="height:400px;flex: 1"></div>
        </div>
    </el-card>
</template>

<script>
import * as echarts from "echarts";
export default {
    data() {
        return {
            myChart: null,
            myChartvariant: null,
            isshow: false,
            colorarr: [
                "rgb(204, 44, 35)",
                "rgb(79, 112, 134)",
                "rgb(97, 160, 168)",
                "rgb(237, 136, 84)",
                "rgb(107, 218, 188)",
                "rgb(81, 190, 232)",
                "rgb(235, 162, 81)",
                "rgb(200, 219, 141)",
                "rgb(155, 170, 194)",
                "rgb(159, 146, 151)"
            ]
        };
    },
    methods: {
        screenWidth() {
            this.myChart.resize();
        },
        getData() {
            if (this.isshow) {
                return;
            }
            this.isshow = true;
            this.myChartvariant = echarts.init(
                document.getElementById("variant2_1")
            );
            let oneDay = 24 * 3600 * 1000;
            let base = +new Date(2019, 9, 3);
            let dates = [];
            let datas = [];
            for (let i = 1; i < 200; i++) {
                let now = new Date((base += oneDay));
                dates.push(
                    [now.getFullYear(), now.getMonth() + 1, now.getDate()].join(
                        "-"
                    )
                );
            }
            for (let j = 0; j < 10; j++) {
                let obj_data = [];
                for (let i = 1; i < 200; i++) {
                    obj_data.push(Math.floor(Math.random() * (0 - i) + i));
                }
                let obj = {
                    name: "价格：",
                    type: "line",
                    data: obj_data,
                    itemStyle: {
                        color: this.colorarr[j % 10]
                    },
                    lineStyle: {
                        color: this.colorarr[j % 10]
                    },
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 1,
                                color: this.colorarr[j % 10]
                            }
                        ])
                    },
                    stack: "总量",
                    emphasis: {
                        lineStyle: {
                            width: 2
                        }
                    }
                };
                datas.push(obj);
            }
            this.viewChartsvariant2_2(dates, datas);
            this.getDataVariant(dates[dates.length - 1]);
        },
        getDataVariant(date_name) {
            let date = [
                "B09G2RR5J2",
                "SJALKSDJAL",
                "AS5D64A65D",
                "Z65X46Z5C4",
                "QW4E654Q4Q",
                "Z654C65Z4C",
                "Q654EQ6Q5E",
                "A564DS4AA6",
                "251A1SD123",
                "65A4DS321A"
            ];
            let data = [];
            for (let i = 0; i < date.length; i++) {
                let obj = {};
                obj.value = Math.floor(Math.random() * (1 - 100) + 100);
                obj.name = date[i];
                obj.title = "标题as5d4645";
                obj.index = i;
                data.push(obj);
            }
            this.viewCharts(date_name, data);
        },
        viewChartsvariant2_2(date, data) {
            this.myChart = echarts.init(document.getElementById("variant2_2"));
            let that = this;
            let option = {
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    borderColor: "rgba(0, 0, 0, 0.6)",
                    textStyle: {
                        color: "rgb(255, 255, 255)"
                    },
                    position: function(pos, params, el, elRect, size) {
                        var obj = {
                            top: 10
                        };
                        obj[
                            ["left", "right"][+(pos[0] < size.viewSize[0] / 2)]
                        ] = 30;
                        return obj;
                    },
                    formatter: function(params) {
                        that.getDataVariant(params[0].axisValue);
                        var htmlStr = "";
                        for (var i = 0; i < params.length; i++) {
                            var param = params[i];
                            var xName = param.name;
                            var seriesName = param.seriesName;
                            var value = param.value;
                            var color = param.color;
                            if (i === 0) {
                                htmlStr += xName + "<br/>";
                            }
                            htmlStr += "<div>";
                            //为了保证和原来的效果一样，这里自己实现了一个点的效果
                            htmlStr +=
                                "<span style='margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:" +
                                color +
                                ";'></span>";
                            let str = value == null ? "--" : value;
                            htmlStr += seriesName + "：" + str;
                            htmlStr += "</div>";
                        }
                        return htmlStr;
                    },
                    axisPointer: {
                        animation: false
                    }
                },
                title: {
                    text: "个",
                    textStyle: {
                        color: "#aaa",
                        fontStyle: "normal",
                        fontSize: "15",
                        lineHeight: 50
                    },
                    left: "2%",
                    top: "0"
                },
                dataZoom: [
                    {
                        type: "inside",
                        start: 80,
                        end: 100
                    },
                    {
                        start: 80,
                        end: 100
                    }
                ],
                grid: {
                    left: "7%",
                    right: "3%",
                    top: "12%"
                },
                xAxis: {
                    type: "category",
                    data: date,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: "rgb(240, 240, 240)",
                            type: "dashed"
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: "rgb(60, 60, 60)"
                    }
                },
                yAxis: {
                    type: "value",
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed"
                        }
                    }
                },
                series: data
            };
            // 绘制图表
            this.myChart.setOption(option);
        },
        viewCharts(date_name, datas) {
            let that = this;
            let option = {
                tooltip: {
                    trigger: "item",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    borderColor: "rgba(0, 0, 0, 0.6)",
                    padding: 4,
                    textStyle: {
                        color: "rgb(255, 255, 255)",
                        fontSize: 15
                    },
                    formatter: function(params) {
                        var htmlStr = "";
                        htmlStr +=
                            "<span>特征：</span>" + params.name + "<br/>";
                        htmlStr +=
                            "<span style='display: inline-block;'>总数：" +
                            params.data.index +
                            "个<span>" +
                            "<br/>" +
                            "<span style='display: inline-block;'>百分比：" +
                            params.percent +
                            "%<span>";
                        return htmlStr;
                    }
                },
                graphic: [
                    {
                        type: "text",
                        top: "48.5%",
                        left: "center",
                        style: {
                            text: date_name,
                            fontSize: 12,
                            fontWeight: "800"
                        }
                    }
                ],
                series: [
                    {
                        name: "brs",
                        type: "pie",
                        radius: ["30%", "70%"],
                        label: {
                            formatter: "{b|{b}}\n{hr|}\n  {c}个  {per|{d}%}",
                            backgroundColor: "rgb(248, 248, 248)",
                            borderColor: "rgb(232, 232, 232)",
                            borderWidth: 1,
                            borderRadius: 4,
                            rich: {
                                b: {
                                    color: "#6E7079",
                                    lineHeight: 22,
                                    align: "center",
                                    padding: [0, 8]
                                },
                                hr: {
                                    borderColor: "rgb(232, 232, 232)",
                                    width: "100%",
                                    borderWidth: 1,
                                    height: 0
                                },
                                per: {
                                    color: "#6E7079",
                                    lineHeight: 22,
                                    align: "center"
                                },
                                c: {
                                    color: "#6E7079",
                                    lineHeight: 22
                                }
                            }
                        },
                        data: datas,
                        itemStyle: {
                            color: function(params) {
                                return that.colorarr[params.dataIndex];
                            }
                        }
                    }
                ]
            };
            // 绘制图表
            this.myChartvariant.setOption(option);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
</style>
